export function renderClusterHtml(count, zoom, showCardMinZoom) {
  const shouldShowPropertiesLabel =
    zoom !== undefined && zoom >= showCardMinZoom;
  const displayText = shouldShowPropertiesLabel ? `${count} properties` : count;

  return `
    <div class="marker-content cluster-marker" style="
      background: white;
      border-radius: 35px;
      border: 1px solid #D1D5DB;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 14px;
      font-weight: 600;
      color: white;
      white-space: nowrap;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    ">
      <div class="price" style="
        color: #3B4143;
        font-weight: 600;
      ">
      ${displayText}
      </div>
    </div>
  `;
}
